//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectFace.js";
import "../no/SelectICurve.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"AlignVector",1,"Direction",0],[0,"AlignVectorUserDefined",1,0],[0,"AllowMultiConnections",1,0],[0,"AllowPortEngagement",1,0],[0,"BackExtension",1,"Expression",0],[1,"ClockingAngle",0,"Expression",0],[0,"CutbackLength",1,"Expression",0],[1,"Face",0,"SelectFace",0],[0,"FlowDirection",1,0],[0,"LengthAddition",1,"Expression",0],[1,"Line1",0,"SelectICurve",0],[1,"Line2",0,"SelectICurve",0],[0,"OffsetExpression",1,0],[0,"OffsetVector",1,"Direction",0],[0,"OffsetVectorUserDefined",1,0],[0,"OriginPoint",1,"Point",0],[0,"PortEngagement",1,"Expression",0],[0,"PortExtension",1,"Expression",0],[0,"PortNameString",1,0],[0,"PortType",1,0],[0,"PositioningMethod",1,0],[0,"ReverseVector",1,0],[0,"RotationVector",1,"Direction",0],[0,"SpoolDelimiter",1,0],[0,"StockOffset",1,0]],[[[],"GetConnectionType",{R_:{connectionType:''}},0,0],[["connectionType"],"SetConnectionType",{},1,0]],[]];
SPLM.Routing.QualifyPortBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.QualifyPortBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.QualifyPortBuilder.CreatePortType = Object.freeze({
    "Fitting" : "Fitting", "Fixture" : "Fixture", "Multi" : "Multi"});

SPLM.Routing.QualifyPortBuilder.PositioningMethodType = Object.freeze({
    "PointAndVector" : "PointAndVector", "MidpointOnFace" : "MidpointOnFace", "BetweenTwoLines" : "BetweenTwoLines"});

export default SPLM;